interface TutorSpeedDialProps {
  min: number;
  max: number;
  step: number;
  value: number;
  isPending: boolean;
  error: string | null;
  onPreview: (value: number) => void;
  onCommit: (value: number) => void | Promise<void>;
}

export function TutorSpeedDial({
  min,
  max,
  step,
  value,
  isPending,
  error,
  onPreview,
  onCommit,
}: TutorSpeedDialProps) {
  return (
    <div className="relative flex items-center gap-1.5" data-testid="tutor-speed-control">
      <label className="group flex flex-col gap-1" title="Applies to the tutor's next reply">
        <span className="flex items-center justify-between text-[9px] font-semibold leading-none text-white/65 sm:text-[10px]">
          <span>Speed</span>
          <span className="tabular-nums">{value.toFixed(1)}×</span>
        </span>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={isPending}
          onChange={(event) => onPreview(Number(event.currentTarget.value))}
          onPointerUp={() => void onCommit(value)}
          onKeyUp={() => void onCommit(value)}
          onBlur={() => void onCommit(value)}
          className="tutor-speed-slider h-1 w-12 cursor-pointer disabled:cursor-wait disabled:opacity-50 sm:w-20"
          aria-label="Tutor speaking speed"
          aria-valuetext={`${value.toFixed(1)} times normal speed`}
        />
      </label>

      {isPending && (
        <span className="sr-only" role="status">
          Updating tutor speed
        </span>
      )}
      {error && (
        <span
          role="alert"
          className="absolute right-0 top-full z-30 mt-1 w-44 rounded-md border border-red-400/25 bg-[#18131a] px-2 py-1 text-[10px] text-red-200 shadow-xl"
        >
          {error}
        </span>
      )}
    </div>
  );
}
